import { Modal } from 'antd';
import { stopImpersonation } from '../../services/impersonationService';
import { spacing } from '../../theming';

// a new session needs a fresh TOTP step-up in the dealer app, so stopping is confirmed first
export const confirmStopImpersonation = t =>
    Modal.confirm({
        title: `${t('confirmModal:actions.impersonate-stop')}?`,
        icon: null,
        // App.scss zeroes modal padding; the app's other confirmations add it back the same way
        styles: { body: { padding: spacing[4] } },
        okButtonProps: { danger: true },
        okText: t('confirmModal:buttons.yes'),
        cancelText: t('confirmModal:buttons.cancel'),
        onOk: stopImpersonation,
    });
